export default __webpack_public_path__ + "images/c2979f32410e55cf63569fb5e4c3a479.png";